import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQrOverlay = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 1024 1024",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		id: "Overlay",
		clipPath: "url(#clip0_2164_30554)",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Subtract",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M0 0H1024V1024H0V0ZM169.301 169.301H851.968V851.968H169.301V169.301ZM128.341 128.341H180.224V145.734H145.168V182.955H128.341V128.341ZM128.341 892.928H180.224V875.536H145.168V838.315H128.341V892.928ZM892.928 892.928H841.045V875.536H876.101V838.315H892.928V892.928ZM892.928 128.341H841.045V145.734H876.101V182.955H892.928V128.341Z",
			fill: props.fill,
			fillOpacity: .3
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2164_30554",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 1024,
			height: 1024,
			fill: "white"
		})
	}) })]
});
export default SvgQrOverlay;
